/**
 * @file ConfirmationModal.jsx
 * @description Reusable Material Design 3 confirmation modal component
 */

import React from "react";
import { Icon } from "./Icon";

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmIcon = "check",
  isDestructive = false,
  isLoading = false
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{ 
        padding: '24px', 
        maxWidth: '400px',
        margin: '16px',
        backgroundColor: 'var(--md-sys-color-surface-container-high)',
        borderRadius: '12px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        border: '1px solid var(--md-sys-color-outline-variant)'
      }}>
        <h3 style={{ 
          margin: '0 0 16px 0',
          color: 'var(--md-sys-color-on-surface)',
          fontSize: '20px',
          fontWeight: '500'
        }}>
          {title}
        </h3>
        <p style={{ 
          margin: '0 0 24px 0',
          color: 'var(--md-sys-color-on-surface-variant)',
          lineHeight: '1.4'
        }}>
          {message}
        </p>
        <div style={{ 
          display: 'flex', 
          gap: '8px',
          justifyContent: 'flex-end'
        }}>
          <button 
            onClick={onClose}
            {...(isLoading ? { disabled: true } : {})}
            style={{
              padding: '10px 16px',
              border: 'none',
              borderRadius: '20px',
              backgroundColor: 'transparent',
              color: 'var(--md-sys-color-primary)',
              fontSize: '14px',
              fontWeight: '500',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit',
              opacity: isLoading ? 0.6 : 1
            }}
          >
            {cancelText}
          </button>
          <button 
            onClick={handleConfirm}
            {...(isLoading ? { disabled: true } : {})}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 24px',
              border: 'none',
              borderRadius: '20px',
              backgroundColor: isDestructive 
                ? 'var(--md-sys-color-error)' 
                : 'var(--md-sys-color-primary)',
              color: isDestructive 
                ? 'var(--md-sys-color-on-error)' 
                : 'var(--md-sys-color-on-primary)',
              fontSize: '14px',
              fontWeight: '500',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontFamily: 'inherit',
              opacity: isLoading ? 0.6 : 1
            }}
          >
            {isLoading ? (
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid currentColor',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
            ) : (
              <Icon name={confirmIcon} />
            )}
            {confirmText}
          </button>
        </div>
      </div>

      {/* Add spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};
